import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../../sdk/src/components/ibase-page/ibase-page.component';
import {S3BucketCRUDComponent} from '../../../components/s3-bucket-crud/s3-bucket-crud.component';

@Component({
    selector: 'app-ga-s3-buckets-page',
    templateUrl: './s3-buckets-page.component.html',
    imports: [PrimeNgImportsModule, S3BucketCRUDComponent, S3BucketCRUDComponent]
})
export class GS3BucketsPage extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
